import { CdnIcon, Span, StatusBanner } from '@pcln/horizon'
import { PKG_ERROR_TYPES } from '../errorTypes'

type ErrorContent = {
  heading: string
  caption?: string
}

const ERROR_COPY: Record<string, ErrorContent> = {
  [PKG_ERROR_TYPES.HTL_CART_ERR]: {
    heading: 'Uh oh! It looks like your package search expired.',
    caption: 'The page may have been left open too long. Check your location & dates and try again!',
  },
  [PKG_ERROR_TYPES.PKG_SEARCH_EMPTY_OR_INVALID_CART]: {
    heading: 'Uh oh! It looks like your package search expired.',
    caption: 'The page may have been left open too long. Check your location & dates and try again!',
  },
  [PKG_ERROR_TYPES.PKG_FLIGHT_ERROR]: {
    heading: 'Uh oh! We were unable to complete your flight package search.',
    caption: 'Check your location & dates and try again!',
  },
  [PKG_ERROR_TYPES.GET_USP_VEHICLES_ERROR]: {
    heading: "Uh oh! We can't find any rental cars that match your search.",
    caption:
      'Rental car counters at the airport may be closed during your arrival or departure time. Please update your search and try again',
  },
}

const DEFAULT_COPY: ErrorContent = {
  heading: 'Uh oh! Something went wrong with your search.',
}

type GenericErrorBannerProps = {
  errorType?: string
}

export default function GenericErrorBanner({ errorType }: Readonly<GenericErrorBannerProps>) {
  const { heading, caption } = (errorType && ERROR_COPY[errorType]) || DEFAULT_COPY

  return (
    <StatusBanner
      headingNode={
        <Span textStyle='body2' bold>
          {heading} {!caption && <Span style={{ fontWeight: 'normal' }}>Please try again.</Span>}
        </Span>
      }
      captionNode={caption ? <Span textStyle='body2'>{caption}</Span> : undefined}
      palette='caution'
      iconNode={<CdnIcon iconName='error' />}
    />
  )
}
